import { render, staticRenderFns } from "./departmentManage.vue?vue&type=template&id=534ba89b&scoped=true"
import script from "./departmentManage.vue?vue&type=script&lang=js"
export * from "./departmentManage.vue?vue&type=script&lang=js"
import style0 from "./departmentManage.vue?vue&type=style&index=0&id=534ba89b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ba89b",
  null
  
)

export default component.exports